<template>
    <div class="template">
        <div class="header">
            <h2 class="title">模板展示</h2>
            <h3 class="subtitle">做更好的服务，提供优秀的产品，为您解决问题！</h3>
        </div>
        <div class="content">
            <div class="nav">
                <div class="nav-item" v-for="(item, index) in typeList" :key="index" @click="handleSelect(item.type)" :class="{ 'active': item.type == type }">
                    {{ item.type }}
                </div>
            </div>
            <div class="template-list">
                <div class="template-item" v-for="(item, index) in templateList" :key="index" @click="goInfo(item)">
                    <div class="template-item-img">
                        <img :src="'https://www.limingsoftware.top' + item.image" alt="">
                    </div>
                    <div class="template-item-title">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="pagination-box">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="changeCurrent"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { get, post, put, del } from '../utils/http'
export default {
    name: 'Template',
    data() {
        return {
            typeList: [],
            templateList: [],
            total:0,
            type:''
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            post('index/getTemplateTypeList').then(res => {
                console.log(res)
                if (res.code == 1) {
                    this.typeList = res.data
                    this.type=res.data[0].type
                    this.handleSelect(res.data[0].type)
                }
            })
        },
        handleSelect(type) {
            this.type = type
            post('index/getTemplateList', { type: type }).then(res => {
                console.log(res)
                if (res.code == 1) {
                    this.total  = res.data.total
                    this.templateList = res.data.data
                }
            })
        },
        changeCurrent(size){
            post('index/getTemplateList', { type: this.type, page: size }).then(res => { 
                if (res.code == 1) {
                    this.templateList = res.data.data
                }
            })
        },
        goInfo(item){
            this.$router.push({
                path: '/templateInfo',
                query: {
                    id: item.template_id
                }
            })
        }
    }
}
</script>

<style scoped>
.template {
    min-height: 100vh;
}

.header {
    height: 360px;
    background: url('../assets/images/hhn5.jpg');
}

.header .title {
    text-align: center;
    line-height: 200%;
    font-size: 40px;
    font-family: 微软雅黑;
    color: rgb(255, 255, 255);
    padding-top: 100px;
}

.header .subtitle {
    text-align: center;
    line-height: 200%;
    font-size: 20px;
    font-family: 微软雅黑;
    color: rgb(255, 255, 255);
}

.content {
    width: 1200px;
    margin: 0 auto;
}

.nav {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    display: flex;
    align-items: center;
    color: var(--text-primary);
    background-color: var(--bg-card);
    border: none;
    margin: 20px 0;
}

.nav .nav-item {
   
    padding: 0 20px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    font-family: 微软雅黑;
    color: var(--text-primary);
    cursor: pointer;
   
}
 .active{
    color: var(--accent-light) !important;
    border-bottom: 2px solid var(--accent-primary);
}
.nav .nav-item:hover {
    color: var(--accent-light);
    border-bottom: 2px solid var(--accent-primary);
}

.template-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 20px;
    column-gap: 20px;
  
}

.template-list .template-item {
    width: 100%;
    height: 300px;
    cursor: pointer;
    border-radius: 10px;
    overflow: hidden;
}

.template-list .template-item:hover {
    box-shadow: 0 0px 13px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease 0s;
    transform: scale(1.01);
}

.template-list .template-item .template-item-img {
    width: 100%;
    height: 250px;
    border-radius: 10px;
    overflow: hidden;
}

.template-list .template-item .template-item-img img {
    width: 100%;
    height: 100%;
}

.template-list .template-item .template-item-title {
    font-size: 16px;
    font-weight: 600;
    padding: 10px 0;
    text-align: center;
    color: var(--text-primary);
}
.pagination-box{
    margin-top: 50px;
    width: 100%;
    height: 50px;
    display: flex;
    align-content: center;
    justify-content: center;
}
</style>